import { injectMetadata } from "../helpers";
import {
  CreateFunnel,
  CreateFunnelWithCollections,
  GetFunnelCollection,
  ListenFunnelCollection,
  UpdateFunnelCollection
} from "../types";

export const createFunnel = ({ documentId, firebase, name }: CreateFunnel): Promise<any> =>
  firebase.db
    .collection(name)
    .doc(documentId)
    .set(injectMetadata({}, firebase), { merge: true });

export const getFunnelCollection = ({
  documentId,
  firebase,
  funnelName,
  name
}: GetFunnelCollection): Promise<any> =>
  firebase.db
    .collection(funnelName)
    .doc(documentId)
    .collection(name)
    .doc(documentId)
    .get()
    .then(
      (snapshot): Promise<DocumentData> => {
        if (snapshot.exists) return snapshot.data();
        return Promise.reject(snapshot);
      }
    );

export const updateFunnelCollection = ({
  data,
  documentId,
  firebase,
  funnelName,
  name,
  setOptions
}: UpdateFunnelCollection): Promise<void> =>
  firebase.db
    .collection(funnelName)
    .doc(documentId)
    .collection(name)
    .doc(documentId)
    .set(injectMetadata(data, firebase), { merge: true, ...setOptions });

export const listenFunnelCollection = ({
  documentId,
  firebase,
  funnelName,
  name,
  onError,
  onSuccess
}: ListenFunnelCollection): (() => void) =>
  firebase.db
    .collection(funnelName)
    .doc(documentId)
    .collection(name)
    .doc(documentId)
    .onSnapshot(onSuccess, onError);

export const createFunnelWithCollections = ({
  documentId,
  firebase,
  name,
  collections
}: CreateFunnelWithCollections): Promise<any> =>
  createFunnel({ documentId, firebase, name }).then(() => {
    const promises = collections.map(collection =>
      updateFunnelCollection({
        documentId,
        firebase,
        data: injectMetadata(collection.data, firebase),
        funnelName: name,
        name: collection.name
      })
    );
    return Promise.all(promises);
  });
